<template>

  <div id="wizard" class="container">
    
    <div id="rep_error" ref="rep_error" v-if="reperror" class="alert alert-danger mt-4 text-center" role="alert">
        <div>{{ error_message }}</div>
    </div>
    
    <form id="wizardmenu" v-if="wizardshow" >

      <form-wizard shape="circle" color="#3498db" title="" subtitle="">
        
        <wizard-step v-if="tabIsDisabled"
          slot-scope="props"
          slot="step"
          :tab="props.tab"
          :transition="props.transition"
          :index="props.index">
        </wizard-step>

        <tab-content :isdisabled="tabIsDisabled" title="Company Information" icon="ti-settings" :before-change="()=>validateStep('StepCompany')">
          <StepCompany ref="StepCompany" @on-validate="mergePartialModels"></StepCompany>
        </tab-content>

        <tab-content :isdisabled="tabIsDisabled" title="Administrator User" icon="ti-email" :before-change="()=>validateStep('StepUser')">
          <StepUser ref="StepUser" :results="finalModel" @on-validate="mergePartialModels"></StepUser>
        </tab-content>

        <tab-content v-if="forclearlyip" :isdisabled="tabIsDisabled" title="General Configuration" icon="ti-files" :before-change="()=>validateStep('StepConfigure')">
          <StepConfigure ref="StepConfigure" :results="finalModel" @on-validate="mergePartialModels"></StepConfigure>
        </tab-content>

        <tab-content v-else :isdisabled="tabIsDisabled" title="Markets & Plans" icon="ti-files" :before-change="()=>validateStep('StepMarket')">
          <StepMarket ref="StepMarket" :results="finalModel" @on-validate="mergePartialModels"></StepMarket>
        </tab-content>

        <tab-content :isdisabled="tabIsDisabled" title="Review & Submit" icon="ti-agenda" :before-change="()=>validateStep('StepConfirm')">
          <StepConfirm ref="StepConfirm" :results.sync="finalModel"></StepConfirm>
        </tab-content>

        <div slot="footer" slot-scope="props">
          <div class="wizard-footer-left">
            <b-button variant="primary" size="lg" v-if="props.activeTabIndex > 0" @click="props.prevTab()" :disabled="buttonIsDisabled">
              <b-icon icon="arrow-left" aria-hidden="true"></b-icon> Back    
            </b-button>
          </div>
          <div class="wizard-footer-right">
            <b-button variant="primary" size="lg" v-if="!props.isLastStep" @click="props.nextTab()" class="wizard-footer-right" :disabled="buttonIsDisabled">
              Next <b-icon icon="arrow-right" aria-hidden="true"></b-icon>
            </b-button>
          
            <b-button variant="primary" size="lg" v-else @click="submit()" class="wizard-footer-right finish-button" :disabled="buttonIsDisabled">
              <span v-if="button_status" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              {{ button_text }}  
            </b-button>
          </div>
        </div>
      </form-wizard>
      
    </form>
    
    <div id="rep_success" v-if="repsuccess" class="alert alert-success mt-4 text-center" role="alert">
      <div>
        {{ success_message }}
      </div>  
      <div class="mt-2 text-center">
        <b-button variant="primary" size="lg" @click="tohomepage()">Back to Home Page</b-button>
      </div>
    </div>

  </div>
</template>

<script>

import axios from 'axios' 

import StepCompany from "./StepCompany.vue"
import StepUser from "./StepUser.vue"
import StepMarket from "./StepMarket.vue"
import StepConfigure from "./StepConfigure.vue"
import StepConfirm from "./StepConfirm.vue"

export default {
  components: {
    StepCompany: StepCompany,
    StepUser: StepUser,
    StepMarket: StepMarket,
    StepConfigure: StepConfigure,
    StepConfirm: StepConfirm
  },
  data() {
    return {
      repsuccess: false,
      success_message: '',     
      wizardshow: true,
      buttonIsDisabled: false,
      tabIsDisabled: false,
      button_status: false,
      button_text: 'Submit',
      reperror: false,
      error_message: '',
      finalModel: {},
      forclearlyip: false,
      currentUrl: location.toString()
    }
  },
  mounted() {
      this.forclearlyip = this.currentUrl.includes("clearlyip");
  },  
  methods: {
    onComplete: function() {
      alert('Yay. Done!');
    },
    tohomepage: function() {
      window.location.href = this.$homeURL;
    },    
    validateStep(name) {
      this.reperror = false;
      var refToValidate = this.$refs[name];
      return refToValidate.validate();
    },
    mergePartialModels(model, isValid){
      if(isValid){
      // merging each step model into the final model
       this.finalModel = Object.assign({},this.finalModel, model)
      }
    },
    submit: function() {
      
      this.reperror = false;
      this.error_message = '';
      
      this.buttonIsDisabled = true;
      this.tabIsDisabled = true;
      this.button_status = true;
      this.button_text = 'Creating your instance, please wait…';

      const headers = {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      } 

      //this.finalModel["market"] = undefined
      //this.finalModel["plans"] = undefined
      //this.finalModel["country"] = undefined
      //this.finalModel["state"] = undefined
      //this.finalModel["countryandstate"] = undefined
      //this.finalModel["options"] = undefined
      //this.finalModel["logofile"] = undefined
      //this.finalModel["cities"] = undefined

      let submitdata = JSON.stringify(this.finalModel)

      axios.post(this.$apiURL,submitdata, {
        headers: headers
        })      
        .then(response => {
          //alert(response.data);
          //console.log(response.data);
          if (response.data['error'] == false) {
            this.success_message = 'You have successfully submitted your information. Your smartbilling instance will be created shortly. You will receive an email to activate your account.';
            this.wizardshow = false;
            this.repsuccess = true;      
          }
          else {
            this.buttonIsDisabled = false;
            this.tabIsDisabled = false;
            this.button_status = false;
            this.button_text = 'Submit';
            
            this.reperror = true;
            if (response.data['message'] != 'Unexpected Error.') {
              this.error_message = response.data['message'];
            }
            else {
              this.error_message = 'Sorry, an unexpected error has occurred. This error has been forwarded to technical support. If you need assistance, you can call customer service at 1 (800) 849-5801 or email us at support@smartbox.ca.';
            }  
            window.scrollTo(0,0);

          }
        })
        .catch(error => {
          alert("Company creation error!")
          this.reperror = true;
          this.error_message = error.message;          
          console.error("There was an error!", error);
          window.scrollTo(0,0);
        });
    },    
  }
}
</script>





// WEBPACK FOOTER //
// src/Wizard.vue